/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Flow_EditInputs */

const en_directory_submit_flow_edit = /** @type {(inputs: Directory_Submit_Flow_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit`)
};

const zh_directory_submit_flow_edit = /** @type {(inputs: Directory_Submit_Flow_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`修改`)
};

/**
* | output |
* | --- |
* | "Edit" |
*
* @param {Directory_Submit_Flow_EditInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_flow_edit = /** @type {((inputs?: Directory_Submit_Flow_EditInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Flow_EditInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_flow_edit(inputs)
	return zh_directory_submit_flow_edit(inputs)
});
export { directory_submit_flow_edit as "directory.submit.flow.edit" }